import { Select2 } from "ng-select2-component";
import { Pagination } from "../core";

export enum ItAssetsConfigurationListItem {
    Category = 'Category',
    Brand = 'Brand',
    Condition = 'Condition',
    Location = 'Location',
    Make = 'Make',
    OS = 'OS',
    Modal = 'Model',
}

export interface ItAssetsConfigurationPayload {
    search?: string;
    limit?: number;
    page?: number;
    customer_type?: string;
    type?: string;
    customer_id?: number;
    company_id?: number;
    status?: string;
}

export class ItAssetsConfigurationItem {
  id!: number;
  name!: string;
  status!: number;
  is_deleted!: number;
  created_at!: string | Date;
  updated_at!: string | Date;
  history!: History[];
}
export class ItAssetsConfigurationCommonResponse {
  success!: boolean;
  message!: string;
}
export class ItAssetsConfigurationResponse extends ItAssetsConfigurationCommonResponse {
  data!: ItAssetsConfigurationItem[];
  pagination!: Pagination;
}

export class AddItAssetsConfigurationResponse extends ItAssetsConfigurationCommonResponse {
  data!: ItAssetsConfigurationItem;
}
export class ItAssetsConfigurationError extends ItAssetsConfigurationCommonResponse {
  error?: any;
}

export class DeletedItAssetsConfiguration extends ItAssetsConfigurationCommonResponse {
  id!: number;
}

export type MasterItAssetsConfigurationItem = {
  [key in ItAssetsConfigurationListItem]: {
    data: ItAssetsConfigurationItem[];
    isLoading: boolean;
    ref?: Select2;
  };
};

